import { render } from "./GenderDistributionChart.vue?vue&type=template&id=6947d612&scoped=true"
import script from "./GenderDistributionChart.vue?vue&type=script&lang=js"
export * from "./GenderDistributionChart.vue?vue&type=script&lang=js"

import "./GenderDistributionChart.vue?vue&type=style&index=0&id=6947d612&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6947d612"

export default script